import { useEffect, useState, useContext } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _btn_ from "@Elementos/Boton";
import * as _ipt_ from "@Elementos/Input";
import * as _anim_ from "@Elementos/Animaciones";

import img_agregar from "@Iconos/agregar.png";
import img_almacen from "@Iconos/almacen.png";
import img_asistencia from "@Iconos/asistencia.png";
import img_borrar from "@Iconos/borrar.png";
import img_despacho from "@Iconos/despacho.png";
import img_editar from "@Iconos/editar.png";
import img_flechaOpciones from "@Iconos/flechaOpciones.png";
import img_generarPedido from "@Iconos/generarPedido.png";
import img_iconopdf from "@Iconos/iconopdf.png";
import img_informacionGeneral from "@Iconos/informacionGeneral.png";
import img_menuOpciones from "@Iconos/menuOpciones.png";
import img_notificacion from "@Iconos/notificacion.png";
import img_pedidos from "@Iconos/pedidos.png";
import img_produccion from "@Iconos/produccion.png";
import img_stock from "@Iconos/stock.png";
import img_usuario from "@Iconos/usuario.png";
import img_ventaTienda from "@Iconos/ventaTienda.png";
import img_xml from "@Iconos/xml.png";
import img_embolsado from "@Iconos/embolsado.png";

import "./MenuOpciones.css";

function MenuOpciones() {
  const origenComponente = "MenuOpciones";

  const { ecv_u, navegacion, enavegacion, opcionMenu, eopcionMenu, rolUsuarioSesion } = useContext(Contexto);

  const [iconos] = useState({
    img_agregar,
    img_almacen,
    img_asistencia,
    img_borrar,
    img_despacho,
    img_editar,
    img_flechaOpciones,
    img_generarPedido,
    img_iconopdf,
    img_informacionGeneral,
    img_menuOpciones,
    img_notificacion,
    img_pedidos,
    img_produccion,
    img_stock,
    img_usuario,
    img_ventaTienda,
    img_xml,
    img_embolsado,
  });

  const [v_u, ev_u] = useState({
    menu: null,
    subMenu: null,
    idMenuHover: null,
    idMenuSeleccionado: null,
    mostrarSubMenu: false,
    subMenuSeleccionado: false,
    estoySubMenu: false,
    descripcionSubMenu: "",
  });

  // Obtener el menú desde la API.
  useEffect(() => {
    const { respuesta } = _api_.f_obtenerMenu({
      origen: origenComponente,
    });

    respuesta.then((datos) => {
      _f_.asignar(ecv_u, datos, true, origenComponente);

      if (!datos.error) {
        ev_u((prev) => ({
          ...prev,
          menu: datos.contenido.menu,
        }));
      }
    });
  }, []);

  // Buscar el programa en el menú principal y sus subopciones.
  function f_buscarOpcion(menu, programa) {
    for (const m of menu ?? []) {
      // Coincidencia con una opción principal.
      if (m.prog === programa && programa !== "") {
        return {
          opcion: m,
          idMenu: m.conf.id,
        };
      }

      // Buscar en las categorías y sus opciones.
      for (const categoria of m.opciones ?? []) {
        for (const subOpcion of categoria.opciones ?? []) {
          if (subOpcion.prog === programa && programa !== "") {
            return {
              opcion: subOpcion,
              idMenu: m.conf.id,
            };
          }
        }
      }
    }

    return null;
  }

  // Seleccionar visualmente según el último elemento de navegacion.
  useEffect(() => {
    if (!v_u.menu?.length || !navegacion?.length) {
      ev_u((prev) => ({
        ...prev,
        idMenuSeleccionado: null,
      }));
      return;
    }

    const ultimaNavegacion = navegacion[navegacion.length - 1];

    if (!ultimaNavegacion?.programa) {
      ev_u((prev) => ({
        ...prev,
        idMenuSeleccionado: null,
      }));
      return;
    }

    const resultado = f_buscarOpcion(v_u.menu, ultimaNavegacion.programa);

    ev_u((prev) => ({
      ...prev,
      idMenuSeleccionado: resultado?.idMenu ?? null,
    }));
  }, [navegacion, v_u.menu]);

  // Seleccionar una opción mediante clic.
  function f_seleccionarOpcion(evento) {
    const elemento = evento.currentTarget;
    console.log(elemento.getAttribute("prog"));
    const programa = elemento.getAttribute("prog");
    const descripcion = elemento.getAttribute("dsc");
    const padre = elemento.getAttribute("padre");

    _f_.f_logicaNavegacion(programa, descripcion, opcionMenu, eopcionMenu, enavegacion);

    if (programa !== "") {
      ev_u((prev) => ({
        ...prev,
        estoySubMenu: false,
        mostrarSubMenu: false,
        idMenuSeleccionado: padre === "true" ? prev.idMenuHover : elemento.id,
      }));
    }
  }

  // Mostrar submenú únicamente si prog está vacío.
  function f_hoverOpcion(evento) {
    const elemento = evento.currentTarget;
    const programa = elemento.getAttribute("prog");
    const idMenu = elemento.id;

    const menuSeleccionado = v_u.menu?.find((m) => m.conf.id === idMenu);

    if (!menuSeleccionado || programa !== "") {
      ev_u((prev) => ({
        ...prev,
        mostrarSubMenu: false,
        estoySubMenu: false,
        subMenu: [],
        idMenuHover: null,
        descripcionSubMenu: "",
      }));

      return;
    }

    ev_u((prev) => ({
      ...prev,
      subMenu: menuSeleccionado.opciones ?? [],
      mostrarSubMenu: true,
      idMenuHover: idMenu,
      descripcionSubMenu: menuSeleccionado.dsc ?? "",
    }));
  }

  function f_hoverSubMenu() {
    ev_u((prev) => ({
      ...prev,
      estoySubMenu: true,
    }));
  }

  function f_dejarSubMenu() {
    ev_u((prev) => ({
      ...prev,
      estoySubMenu: false,
    }));
  }

  function f_dejarOpcion() {
    ev_u((prev) => ({
      ...prev,
      mostrarSubMenu: false,
    }));
  }

  return (
    <>
      <div
        className={`m-o-o-submenu ${v_u.mostrarSubMenu || v_u.estoySubMenu ? "" : "m-o-o-s-ocultar"}`}
        onMouseEnter={f_hoverSubMenu}
        onMouseLeave={f_dejarSubMenu}>
        <div className="m-o-s-cabecera">
          <h4 className="m-o-s-titulo">{v_u.descripcionSubMenu}</h4>
        </div>

        <div className="m-o-s-contenido">
          {v_u.subMenu?.length > 0 ? (
            v_u.subMenu.map((cso, csoi) => (
              <div key={csoi} className="m-o-s-categoria">
                <h5 className="m-o-s-c-descripcion">{cso.dsc}</h5>

                {(cso.opciones ?? []).map((so, soi) => (
                  <button
                    key={soi}
                    type="button"
                    prog={so.prog}
                    dsc={so.dsc}
                    className="m-o-s-c-boton"
                    onClick={f_seleccionarOpcion}
                    padre="true">
                    {so.dsc}
                  </button>
                ))}
              </div>
            ))
          ) : (
            <div className="m-o-s-sin-opciones">
              <span className="m-o-s-sin-opciones-icono">ℹ</span>
              <p>No hay opciones internas</p>
            </div>
          )}
        </div>
      </div>

      <div className="menu-opciones">
        {v_u.menu?.map((m) => (
          <div
            key={m.conf.id}
            className={`m-o-opcion ${m.conf.id === v_u.idMenuSeleccionado ? "seleccionado" : ""}`}
            prog={m.prog}
            dsc={m.dsc}
            onClick={f_seleccionarOpcion}
            onMouseEnter={f_hoverOpcion}
            onMouseLeave={f_dejarOpcion}
            onMouseDown={f_hoverOpcion}
            id={m.conf.id}>
            <img src={iconos["img_" + m.img]} className="m-o-p-icono" alt={m.dsc} />

            <span className="m-o-p-texto">{m.dsc}</span>
          </div>
        ))}
      </div>
    </>
  );
}

export default MenuOpciones;
